import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateArtist, type ArtistDto } from "../api/artistsApi";
import { queryKeys } from "../lib/queryKeys";

export function useUpdateArtist(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: ArtistDto) => updateArtist(id, dto),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.artists.all });
      qc.invalidateQueries({ queryKey: queryKeys.artists.detail(id) });
      qc.invalidateQueries({ queryKey: queryKeys.lieux.all });
    },
  });
}
